import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { Link } from 'react-router-dom';
import {  StarRating, ReviewCount } from '../widgets';
import accreditedImg from '../../assets/acredited-provider-badge.svg';
import placeholderImage from '../../assets/physiotherapist-and-boy-holding-ball-pxfq-9-hy.png';

const useStyles = makeStyles(theme => ({
  link: {
    textDecoration: 'none',
    flexGrow: 1,
  },
  root: {
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    marginBottom: '1rem',
    boxShadow: 'none',
    borderRadius: '3px',
    border: `1px solid ${theme.palette.common.silver}`,
    '&:hover': {
      border: `1px solid ${theme.palette.primary.main}`,
    },
    [theme.breakpoints.down('sm')]: {
      padding: '1rem',
      flexWrap: 'wrap',
      justifyContent: 'center',
    },
  },
  coverImg: {
    flexShrink: 0, // prevents image resizing during page load
    width: 200,
    margin: '0 1rem',
    [theme.breakpoints.down('sm')]: {
      width: '70%',
      margin: '1rem 0',
    },
  },
  accreditedImg: {
    height: '2rem',
    [theme.breakpoints.down('sm')]: {
      margin: '1rem 0 0.5rem 0',
    },
  },
  titleBox: {
    width: '100%',
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
    },
  },
  text: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  content: {
    width: '100%',
  },
  widgets: {
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '0.5rem 0',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
      marginBottom: '0.5rem',
    },
  },
  widgetText: {
    padding: 0,
    paddingLeft: '5px',
    fontSize: '0.9rem',
    color: theme.palette.primary.main,
  },
}));

const ProviderCard = ({data}) => {
  const classes = useStyles();
  const imageSize = '@200x112';
  const img = data.image_path ? data.image_path + imageSize : placeholderImage;
  const linkUrl = (query='') => `/provider/${data.slug}${query}`;
  return (
    <Link className={classes.link} to={linkUrl()}>
      <Card className={classes.root}>
        <CardMedia
          className={classes.coverImg}
          component="img"
          src={img}
          role="presentation"
        />
        <CardContent className={classes.content}>
          <div className={classes.titleBox}>
            <Typography variant="h6" color="primary" className={classes.text}>{data.name}</Typography>
            {data.accredited && (
              <img
                src={accreditedImg}
                aria-label="Provider is accredited by Clickability"
                alt="Clikability accredited provider icon"
                className={classes.accreditedImg}
              />
            )}
          </div>
          <Box className={classes.widgets}>
            <StarRating rating={data.rating} />
            <ReviewCount count={data.review_count} />
          </Box>
          <Typography variant="body2" className={classes.text}>{data.short_description}</Typography>
        </CardContent>
      </Card>
    </Link>
  );
};

ProviderCard.propTypes = {
  data: PropTypes.object.isRequired,
};

export default ProviderCard;
